import React from 'react';
import {Bar} from 'react-chartjs-2';
import ChartContainer from './chartContainer';
import { formatNumberToDisplayWithCommas } from '../../../../common/shared';
import {getMonthlyChartLabels, getPeriodAverageValue} from '../chartLabelHelpers';
import './chartSetup';

const ShiftUtilizationChart = ({chartData}) => {
    const labels = getMonthlyChartLabels(chartData.items);
    const values = chartData.items.map(item => item.percentage);

    const data = {
        labels: labels,
        datasets: [
            {
                type: 'bar',
                data: values,
                backgroundColor: '#bfbfbf',
                order: 1,
                label: 'Utilization Per Shift',
            },
        ],
    }

    const options = {
        scales: {
            y: {
                title: 'Shift Utilization',
                beginAtZero: true,
                ticks: {
                    callback: function(value) {
                        return `${value}%`;
                    }
                }
            },
            x: {
                grid: {
                    drawOnChartArea: false,
                    tickLength: 10,
                },
                ticks: {
                    autoSkip: false,
                    maxRotation: 45,
                    minRotation: 0,
                }
            },
        },
        plugins: {
            legend: {
                reverse: true,
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';

                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += `${formatNumberToDisplayWithCommas(context.parsed.y, 1)}%`;
                        }
                        return label;
                    }
                },
            },
        },
        maxBarThickness: 40,
    }

    const summaryItems = [
        {
            label: 'Period Avg',
            value: `${formatNumberToDisplayWithCommas(getPeriodAverageValue(chartData), 1)}%`,
        },
    ]

    return (
        <ChartContainer title="Shift Utilization" summaryItems={summaryItems}>
            <Bar data={data} options={options}/>
        </ChartContainer>
    )
}

export default ShiftUtilizationChart;
